import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Loader2, RotateCcw } from "lucide-react";
import { api, errorText } from "../lib/api";
import { fmtDate } from "./AuthContext";

const COLORS = { sent: "text-emerald-300", failed: "text-red-300", skipped: "text-gray-400", pending: "text-yellow-300" };

export default function Notifications() {
  const [rows, setRows] = useState(null);
  const [status, setStatus] = useState("");
  const [tick, setTick] = useState(0);

  useEffect(() => {
    api.get("/admin/notifications", { params: { status } }).then((r) => setRows(r.data)).catch(() => setRows([]));
  }, [status, tick]);

  const retry = async (id) => {
    try {
      await api.post(`/admin/notifications/${id}/retry`);
      toast.success("Retry started");
      setTimeout(() => setTick((x) => x + 1), 2500);
    } catch (e) { toast.error(errorText(e)); }
  };

  return (
    <div className="space-y-6" data-testid="admin-notifications-page">
      <h1 className="text-3xl sm:text-4xl font-extrabold uppercase">Notification log</h1>
      <p className="text-sm text-gray-400">Shows every email and SMS attempt. “Sent” means the provider accepted the message. “Skipped” means the channel or recipient is not configured.</p>
      <select className="tow-input w-auto" value={status} onChange={(e) => setStatus(e.target.value)} data-testid="admin-notif-filter" aria-label="Filter">
        <option value="">All</option><option value="sent">Sent</option><option value="failed">Failed</option><option value="skipped">Skipped</option><option value="pending">Pending</option>
      </select>
      {!rows ? <Loader2 className="h-6 w-6 animate-spin text-[#FACC15]" /> : rows.length === 0 ? <p className="panel p-6 text-gray-400">No notification attempts yet.</p> : (
        <div className="overflow-x-auto rounded-xl border border-[#2E2E3A]">
          <table className="w-full min-w-[760px] text-sm" data-testid="admin-notif-table">
            <thead className="bg-[#121216] text-left text-xs uppercase text-gray-400"><tr><th className="p-3">Time</th><th className="p-3">Request</th><th className="p-3">Type</th><th className="p-3">Recipient</th><th className="p-3">Status</th><th className="p-3">Details</th><th className="p-3" /></tr></thead>
            <tbody>
              {rows.map((n) => (
                <tr key={n.id} className="border-t border-[#2E2E3A]" data-testid={`notif-row-${n.id}`}>
                  <td className="p-3 whitespace-nowrap text-gray-300">{fmtDate(n.created_at)}</td>
                  <td className="p-3 font-mono text-[#FACC15]">{n.ref}</td>
                  <td className="p-3">{n.kind.replace("_", " ")}</td>
                  <td className="p-3 text-gray-300">{n.recipient || "—"}</td>
                  <td className={`p-3 font-semibold ${COLORS[n.status]}`}>{n.status}</td>
                  <td className="p-3 text-xs text-gray-500 max-w-xs">{n.error || (n.attempts ? `${n.attempts} attempt(s)` : "")}</td>
                  <td className="p-3">{n.status !== "sent" && <button type="button" onClick={() => retry(n.id)} className="btn-ghost px-3 py-1 text-xs" data-testid={`notif-retry-${n.id}`}><RotateCcw className="h-3 w-3" /> Retry</button>}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
